import Permission from '../../models/Permission.class';
import { RootState } from '../root-state';

export const getAuthStatus = (state: RootState): boolean | undefined => state.auth.isSignedIn;

export const getPermissions = (state: RootState): Permission[] | undefined => state.auth.permissions;
